import React, { useEffect, lazy } from 'react';
import InsertApplicant from '../../Applicant/insertApplicant';

const Modal = lazy(() => import('reactstrap/lib/Modal'));
const EditApplicantModal = ({ isOpen, applicant, closeModal, refreshApplicant }) => {
  return (
    <Modal isOpen={isOpen} style={{ maxWidth: '1800px' }} centered>
      <InsertApplicant
        applicant={applicant}
        closeModal={closeModal}
        refreshApplicant={refreshApplicant}
      ></InsertApplicant>
    </Modal>
  );
};

export default EditApplicantModal;
